import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, Observable, throwError } from "rxjs";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(public router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            withCredentials: true,
        });
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                if(error.status === 401){
                    //redirect to login page
                    this.router.navigate(['/auth']);
                }
                //throw error as per requirement
                return throwError(() => error);
            })
        );
    }

}